import { TNode } from '../domain/tnode';

export class TNodesUtil {
    private static instance: TNodesUtil;

    static getInstance() {
        if (!TNodesUtil.instance) {
            TNodesUtil.instance = new TNodesUtil();
        }

        return TNodesUtil.instance;
    }

    /**
    * TNodesUtil is a singleton class, so use TNodesUtil.getInstance() method instead of creating new TNodesUtil().
    */
    private constructor() {

    }

    copy(tNodesTmp: Array<TNode>): Array<TNode> {
        let tNodes: Array<TNode> = new Array<TNode>();

        for (let i: number = 0; i < tNodesTmp.length; i++) {
            tNodes.push(tNodesTmp[i].copy());
        }

        return tNodes;
    }

    copyFrom(tNodes: Array<TNode>, tNodesTmp: Array<TNode>): void {
        let tNodesMap: Map<number, TNode> = new Map();

        for (let i: number = 0; i < tNodes.length; i++) {
            let tNode: TNode = tNodes[i] as TNode;
            tNodesMap.set(tNode.id, tNode);
        }

        tNodes.splice(0, tNodes.length);

        for (let i: number = 0; i < tNodesTmp.length; i++) {
            let tNodeTmp: TNode = tNodesTmp[i] as TNode;

            let tNode: TNode = tNodesMap.get(tNodeTmp.id);
            if (tNode) {
                tNode.copyFrom(tNodeTmp);
            } else {
                tNode = TNode.parse(tNodeTmp);
            }

            tNodes.push(tNode);
        }
    }

    toString(tNodes: Array<TNode>): string {
        let str: string = '';

        str += 'tNodes length: ' + tNodes.length + ' ';

        for (let i: number = 0; i < tNodes.length; i++) {
            let tNodeTmp: TNode = tNodes[i] as TNode;
            str += tNodeTmp.toString();
        }

        return str;
    }
}